import React from "react";

const BenchmarkSectoriel = () => {
  return (
    <div className="benchmark-sectoriel">
      <h2>Benchmark sectoriel</h2>
      <p>Comparaison des performances avec le secteur.</p>
    </div>
  );
};

export default BenchmarkSectoriel;
